// The glyph an agent without steps carries (#12414, Gerry: lucide's Bot, a
// little bigger than the Phosphor robot it replaces, with a straight
// antenna ending in a ball in place of lucide's hooked one). Drawn inline
// from lucide's paths so the antenna can differ, at the workflow glyph's
// stroke so the two read as one set in the same tile. The sidebar and the
// admin product list draw it too (Gerry: the left panel's icon as well),
// sized by their own class like their other icons.
import React from "react";

export const RobotGlyph: React.FC<{
  size?: number;
  strokeWidth?: number;
  className?: string;
  // The cropped viewBox (20 units across a 24-unit box) draws a stroke 1.2×
  // its nominal width, so 1.3 here is Phosphor's regular 1.5 on screen
  // (Gerry: "the lines are too thick, not the same as other icons").
}> = ({ size = 18, strokeWidth = 1.3, className }) => (
  <svg
    data-agent-glyph=""
    aria-hidden="true"
    // Cropped to the drawing plus its stroke, so the head fills its box the
    // way the Phosphor icons beside it in the sidebar fill theirs (Gerry:
    // "the icon on the left panel seems too small").
    viewBox="1.2 1.6 21.6 19.4"
    width={size}
    height={size}
    className={className}
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {/* lucide's 16×12 head (Gerry: rectangular, "like before", after a
        squarer 14×13 read as too square). */}
    <path d="M12 8V5" />
    <circle cx="12" cy="3.6" r="1.1" />
    <rect width="16" height="12" x="4" y="8" rx="2" />
    <rect width="2" height="4" x="2" y="12" rx="0.6" />
    <rect width="2" height="4" x="20" y="12" rx="0.6" />
    {/* Eyes between a dot and a line (Gerry): a short round-capped
        stroke, taller than it is wide. */}
    <path d="M9 13.2v1.6" />
    <path d="M15 13.2v1.6" />
  </svg>
);

export default RobotGlyph;
